/**
 *
 * @description æ§ä»¶ç±»ååç§°
 * @export
 */
export class ControlTypeName {
  static textBox = 'TextBox';
  static multiTextBox = 'MultiTextBox';
  static radio = 'Radio';
  static multiCheckBox = 'MultiCheckBox';
  static dropDown = 'DropDown';
  static digital = 'Digital';
  static dateTime = 'DateTime';
  static fileUpLoad = 'FileUpLoad';
  static paragraph = 'Paragraph';
  static email = 'Email';
  static switch = 'Switch';
  static carType = 'CarType';
  static regionSelection = 'RegionSelection';
  static cell: string = 'Cell';
  static row: string = 'Row';
  static container: string = 'Container';
  static childForm: string = 'childForm';
}

/**
 * æ§ä»¶å¹¿æ­äºä»¶åç§°
 *
 */
export class ControlBroadCastEventName {
  /**
   * å¼æ¹å
   */
  static valueChange = 'valueChange';

  /**
   * ç¹å»
   *
   */
  static click = 'click';
}
